import React from 'react';
import FormLabel from '../atoms/FormLabel';
import FormInput from '../atoms/FormInput';
import FormTextarea from '../atoms/FormTextarea';
import FormError from '../atoms/FormError';

/**
 * FormField - Molecular component combining label, input, and error
 * @param {Object} props
 * @param {string} props.label - Field label text
 * @param {boolean} props.required - Whether field is required
 * @param {string} props.error - Error message
 * @param {string} props.type - Input type ('text', 'textarea', 'custom')
 * @param {Object} props.inputProps - Props to pass to input/textarea
 * @param {React.ReactNode} props.children - Custom input component (for type='custom')
 * @param {string} props.className - Additional CSS classes for container
 * @param {string} props.htmlFor - ID for label's htmlFor attribute
 */
export const FormField = ({
    label,
    required = false,
    error,
    type = 'text',
    inputProps = {},
    children,
    className = '',
    htmlFor,
    ...props
}) => {
    const renderInput = () => {
        if (type === 'custom' && children) {
            return children;
        }

        if (type === 'textarea') {
            return <FormTextarea error={!!error} {...inputProps} />;
        }

        return <FormInput error={!!error} {...inputProps} />;
    };

    return (
        <div className={`flex flex-col gap-1 ${className}`} {...props}>
            {label && (
                <FormLabel htmlFor={htmlFor} required={required}>
                    {label}
                </FormLabel>
            )}
            {renderInput()}
            <FormError message={error} />
        </div>
    );
};

export default FormField;
